import Header from "../header/Header";
import { useCallback, useEffect, useState } from "react";
import { FaCirclePlus, FaCircleMinus, FaPlus, FaMinus, FaArrowLeft } from "react-icons/fa6";
import CountrySelectInput from "../shared/countrySelectInput";
import { addDoc, collection } from "firebase/firestore";
import { toast } from "react-toastify";
import { db, storage } from "../../config/firebase";
import { useMyContext } from "../../context/MyContext";
import { api } from "../../config/api";
import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import useNextInquireNumber from "../newRequest/generateInquireNo";
import UploadInvoice from "./UploadInvoice";
import { Progress, Select, Upload } from "antd";
import { countries } from "../shared/countrySelectInput/countries";
import { InboxOutlined } from "@ant-design/icons";
import DashboardLayout from "../layout";
import TransportationMode from "./TransportationMode";
import { useNavigate } from "react-router-dom";

function AddressForm({ onBack }) {
  const obj = {
    ative: true,
    content: " Shipment Details",
  };
  const { user } = useMyContext();
  const [showForm, setShowForm] = useState(true);
  const [showInvoice, setShowInvoice] = useState(false);
  const [requiredDocTouched, setRequiredDocTouched] = useState(false);

  const navigate = useNavigate();

  const handleButtonClick = (buttonType) => {
    if (buttonType === "form") {
      setShowForm(true);
      setShowInvoice(false);
    } else if (buttonType === "invoice") {
      setShowForm(false);
      setShowInvoice(true);
    } else if (buttonType === "bookshipment") {
      navigate('/bookshipment');
    }
  };

  const [loading, setLoading] = useState(false);
  const [totalWeight, setTotalWeight] = useState(0);
  const [creationDate, setCreationDate] = useState(new Date());
  const [termsError, setTermsError] = useState(false);
  const [hasHSCode, setHasHSCode] = useState(true);

  const [successMessageShown, setSuccessMessageShown] = useState(false);
  // console.log(user)
  const [Total, setTotal] = useState(0);
  const { nextInquireNumber } = useNextInquireNumber();

  const [eorGuarantee, setEorGuarantee] = useState(false);
  const [insureShipment, setInsureShipment] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  // console.log(nextInquireNumber)
  const [formData, setFormData] = useState({
    requestStatus: "unquoted",
    inquireNumber: nextInquireNumber,
    name: user?.name || "",
    userId: user?.uid || "",
    email: user?.email || "",
    postalCode: user?.postalCode || "",
    address: user?.address || "",
    city: user?.city || "",
    userCountry: user?.country || "",
    country: "",
    loadName: '',
    loadAddress_PhoneNumber: "",
    loadAddress: "",
    loadAddress2: "",
    loadCountry: "",
    loadCity: "",
    loadPostalCode: "",
    loadAddress_CompanyName: "",
    loadAddress_ReferenceCustomer: "",
    unloadName: "",
    unloadAddress_PhoneNumber: "",
    unloadAddress: "",
    unloadAddress2: "",
    unloadCountry: "",
    unloadCity: "",
    unloadPostalCode: "",
    modeOfTransfer: "By Road",
    unloadAddress_CompanyName: "",
    pkgType: "",
    cargoValue: { value: Total || "", currency: "USD" },
    cifValue: { value: "", currency: "USD" },
    pcsPackage: [
      {
        quantity: "",
        weight: { value: "", unit: "Kg" },
        length: { value: "", unit: "cm" },
        width: { value: "", unit: "cm" },
        height: { value: "", unit: "cm" },
      },
    ],
    totalWeight: totalWeight,
    creationDate: creationDate.toISOString(),
    items: [
      {
        itemName: "",
        itemHSCode: "",
        itemValue: "",
        countryOrigin: "",
        quantity: "",
        hasHSCode: null,
      },
    ],
    total: "",
    subTotal: 0,
    vatPercentage: 0,
    vatAmount: 0,
    currency: "USD",
    docFiles: [],
    manualDescription: "",
    requiredDoc: "",
    serviceType: "",

    invoiceDetail: {
      invoiceFile: null,
      additionDetails: "",
    },
    eorGuarantee: eorGuarantee || "",
    insureShipment: insureShipment || "",
  });

  // console.log("formData", formData);

  useEffect(() => {
    // Retrieve stored data when component mounts
    const storedData = sessionStorage.getItem('estimateFormData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setFormData(prevData => ({
        ...prevData,
        ...parsedData
      }));

      // Clear the stored data after using it
      sessionStorage.removeItem('estimateFormData');
    }
  }, []);

  // Function to handle checkbox changes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === "eorGuarantee") {
      setEorGuarantee(checked);
    } else if (name === "insureShipment") {
      setInsureShipment(checked);
    } else if (name === "agreeTerms") {
      setAgreeTerms(checked);
      if (checked) {
        setTermsError(false);
      }
    }

    // Update formData
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };
  // console.log()
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      inquireNumber: nextInquireNumber || "",
    }));
  }, [nextInquireNumber]);

  useEffect(() => {
    // Calculate Sub Total
    const subTotal = formData.items.reduce((acc, item) => {
      const totalForItem =
        parseFloat(item.quantity || 1) * parseFloat(item.itemValue || 0);
      return acc + totalForItem;
    }, 0);

    // Format total to display only two decimal points
    const formattedTotal = subTotal.toFixed(2);

    // Update state
    setFormData((prevData) => ({
      ...prevData,
      cargoValue: {
        ...prevData.cifValue,
        value: formattedTotal, // Update total
      },
    }));
  }, [formData.items]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "requiredDoc") {
      setRequiredDocTouched(true);
    }
  };

  const handlePcsOfPkgInput = (index, field, e) => {
    const { value } = e.target;

    // Only allow numbers
    if (!/^\d*\.?\d*$/.test(value) || parseFloat(value) < 0) return;

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      if (pcsPackage[index]) {
        if (field === "pcsPackage-quantity") {
          const f = field.split("-");

          pcsPackage[index][f[1]] = value;
        } else {
          pcsPackage[index][field].value = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  const handleUnitChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      if (pcsPackage[index]) {
        if (field === "weight") {
          // Update only the weight unit
          pcsPackage[index].weight.unit = value;
        } else {
          // Update length, width, and height units together
          pcsPackage[index].length.unit = value;
          pcsPackage[index].width.unit = value;
          pcsPackage[index].height.unit = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  useEffect(() => {
    const total = formData.pcsPackage.reduce((acc, pcs) => {
      const weightValue =
        parseFloat(pcs.quantity || 1) * parseFloat(pcs.weight.value || 0);
      return acc + weightValue;
    }, 0);

    setTotalWeight(total); // Update totalWeight state with numeric value
    setFormData((prevData) => ({
      ...prevData,
      totalWeight: total, // Set totalWeight field in formData with numeric value
    }));
  }, [formData.pcsPackage, totalWeight]);

  const handleRemovePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: prevData.pcsPackage.slice(0, -1), // Remove the last added package
    }));
  };
  const handleAddMorePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: [
        ...prevData.pcsPackage,
        {
          quantity: "", // Initialize quantity for each new item
          weight: { value: "", unit: "Kg" },
          length: { value: "", unit: "cm" },
          width: { value: "", unit: "cm" },
          height: { value: "", unit: "cm" },
        },
      ],
    }));
  };

  // const handleRemoveService = () => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     items: prevData.items.slice(0, -1), // Remove the last added service
  //   }));
  // };

  const handleRemoveService = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      items: prevData.items.filter((_, i) => i !== index),
    }));
  };

  const handleAddMore = () => {
    setFormData((prevData) => ({
      ...prevData,
      items: [...prevData.items, {}], // Update 'documents' to 'services'
    }));
  };

  const handleServiceInputChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const updated = [...prevData.items];
      if (field === "item-quantity") {
        const f = field.split("-");
        updated[index][f[1]] = value;
      } else if (field === "hasHSCode") {
        updated[index].hasHSCode = value === "yes";
      } else {
        updated[index][field] = value;
      }

      return {
        ...prevData,
        items: updated,
      };
    });
  };
  const handleAntdServiceInputChange = (index, field, value) => {
    setFormData((prevData) => {
      const updated = [...prevData.items];
      updated[index][field] = value;

      return {
        ...prevData,
        items: updated,
      };
    });
  };
  // console.log(formData)
  const [errors, setErrors] = useState({});

  const validateHSCode = (index) => {
    const item = formData.items[index];
    if (item.hasHSCode === null || item.hasHSCode === undefined) {
      setErrors((prev) => ({
        ...prev,
        [`hasHSCode-${index}`]: "Please select an option",
      }));
      return false;
    }
    if (item.hasHSCode === true && (!item.itemHSCode || item.itemHSCode.trim() === "")) {
      setErrors((prev) => ({
        ...prev,
        [`itemHSCode-${index}`]: "HS Code is required",
      }));
      return false;
    }
    if (item.hasHSCode === false && (!formData.docFiles || formData.docFiles.length === 0)) {
      setErrors((prev) => ({ ...prev, [`docFiles-${index}`]: "Please upload a datasheet" }));
      return false;
    }
    setErrors((prev) => ({
      ...prev,
      [`hasHSCode-${index}`]: null,
      [`itemHSCode-${index}`]: null,
      [`docFiles-${index}`]: null,
    }));
    return true;
  };

  const handleAddData = async (e) => {
    e.preventDefault(); // Prevent form submission from reloading the page

    const invalidFields = [];
    let hasMissingFields = false;

    if (!agreeTerms) {
      setTermsError(true);
      toast.error("Please agree to the terms and conditions.");
      return;
    }
    let hasHSCodeErrors = false;
    formData.items.forEach((item, index) => {
      if (!validateHSCode(index)) {
        hasHSCodeErrors = true;
      }
    });

    if (hasHSCodeErrors) {
      toast.error("Please select a HS Code or upload a datasheet for each item.");
      return;
    }

    // Check if any item has hasHSCode set to false and no docFile uploaded
    const missingDatasheet = formData.items.some((item, index) =>
      item.hasHSCode === false && (!formData.docFiles || formData.docFiles.length === 0)
    );

    if (missingDatasheet) {
      toast.error("Please upload a datasheet for items without HS Code.");
      return;
    }


    const mandatoryFields = [
      "loadName",

      "loadAddress_ReferenceCustomer",
      "loadAddress",
      "loadPostalCode",
      "loadCity",
      "loadCountry",

      "unloadName",

      "unloadAddress",
      "unloadPostalCode",
      "unloadCity",
      "unloadCountry",

      "requiredDoc",
      "serviceType",
    ];

    mandatoryFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        invalidFields.push(field);
        hasMissingFields = true;
      }
    });

    // console.log("Checking pcsPackage...");
    if (formData.pcsPackage.length === 0) {
      // errors.push('At least one package is required');
      // console.log("No packages found");
      hasMissingFields = true;
    } else {
      formData.pcsPackage.forEach((pkg, index) => {
        ["quantity", "weight", "length", "width", "height"].forEach((field) => {
          const elementId = `${field === "quantity" ? `pcsPackage-${field}` : field
            }-${index}`;

          if (
            !pkg[field] ||
            (typeof pkg[field] === "object" && !pkg[field].value) ||
            parseFloat(field === "quantity" ? pkg[field] : pkg[field].value) <=
            0
          ) {
            // console.log(`Missing package field: ${elementId}`);
            invalidFields.push(elementId);
            hasMissingFields = true;
          }
        });
      });
    }

    if (formData.items.length === 0) {
      hasMissingFields = true;
    } else {
      formData.items.forEach((item, index) => {
        ["itemName", "itemValue", "countryOrigin", "quantity"].forEach(
          (field) => {
            const elementId = `${field === "quantity" ? `item-${field}` : field
              }-${index}`;
            if (
              !item[field] ||
              (["itemValue", "quantity"].includes(field) &&
                parseFloat(item[field]) <= 0)
            ) {
              invalidFields.push(elementId);
              hasMissingFields = true;
            }
          }
        );
        // Check itemHSCode only if hasHSCode is true
        if (item.hasHSCode) {
          const elementId = `itemHSCode-${index}`;
          if (
            !item.itemHSCode ||
            item.itemHSCode.length < 6 ||
            item.itemHSCode === null
          ) {
            invalidFields.push(elementId);
            hasMissingFields = true;
            if (!item.itemHSCode) {
              toast.error("HS Code is required when 'Has HS Code' is selected");
            } else if (item.itemHSCode.length < 6) {
              toast.error("HS Code must be at least 6 digits");
            }
          }
        }
      });
    }

    if (!agreeTerms) {
      invalidFields.push("agreeTerms");
      hasMissingFields = true;
    }

    if (hasMissingFields) {
      toast.error("Please fill all required fields.");
      highlightInvalidFields(invalidFields);
      return;
    }

    // console.log(formData);
    try {
      setLoading(true);
      const usersCollection = collection(db, "requests"); // Changed to 'users' collection

      // Allocate a unique inquire number atomically from backend just-in-time
      let allocatedInquireNumber = formData.inquireNumber;
      try {
        const allocRes = await api.post("/firestore/inquire-number/allocate");
        if (allocRes?.data?.inquireNumber) {
          allocatedInquireNumber = allocRes.data.inquireNumber;
        }
      } catch (allocErr) {
        console.error("Failed to allocate inquire number, falling back to preview value.", allocErr);
      }

      const trimmedFormData = Object.keys(formData).reduce((acc, key) => {
        acc[key] =
          typeof formData[key] === "string"
            ? formData[key].trim()
            : formData[key];
        return acc;
      }, {});

      const payload = {
        ...trimmedFormData,
        inquireNumber: allocatedInquireNumber || trimmedFormData.inquireNumber || "",
      };

      const docRef = await addDoc(usersCollection, payload);

      // await api.post("/notifications", {
      //   userId: formData?.userId,
      //   title: "New Quote Request",
      //   message: `A new quote request has been submitted by ${formData.name}`,
      //   linkText: "View Quote",
      //   link: `/quoteadmin?quote=${docRef.id}`,
      //   role: user?.role,
      //   quoteNumber: formData.inquireNumber,
      //   type: "quotes"  // Adding type field for consistency with existing notifications
      // });

      await api.post("/notifications", {
        title: "New Inquiry Request",
        message: `A new Inquiry request has been submitted by ${formData.name}`,
        linkText: "View Quote",
        link: `/newRequest`,
        role: "admin",
        quoteNumber: allocatedInquireNumber || payload.inquireNumber,
        type: "new-inquiry",
      });

      toast.success("Data submitted successfully!");

      window.location.reload();
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
    if (!validatePhoneNumber(formData.loadAddress_PhoneNumber)) {
      toast.error("Please enter a valid valid phone number.");
      return;
    }
  };

  const highlightInvalidFields = (invalidFields) => {
    // console.log("AMPM invalid fields", invalidFields);
    invalidFields.forEach((field) => {
      if (field === "requiredDoc") {
        setRequiredDocTouched(true);
      } else {
        const element = document.getElementById(field);
        if (element) {
          element.style.border = "2px solid red";
        }
      }
    });

    // Remove highlight after 3 seconds
    setTimeout(() => {
      invalidFields.forEach((field) => {
        if (field === "requiredDoc") {
          setRequiredDocTouched(false);
        } else {
          const element = document.getElementById(field);
          if (element) {
            element.style.border = "";
          }
        }
      });
    }, 3000);
  };

  const [progress, setProgress] = useState(0);

  const handleFileUpload = useCallback(async (file) => {
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
      "image/jpeg",
      "image/png",
      "image/gif",
    ];
    if (!allowedTypes.includes(file.type)) {
      // Handle file type error
      setErrors((prevErrors) => ({
        ...prevErrors,
        docFiles: "Invalid file type",
      }));
      return;
    }

    setLoading(true);
    try {
      const storageRef = ref(storage, `invoiceFiles/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progressPercentage = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setProgress(progressPercentage);
        },
        (error) => {
          setLoading(false);
          // {/* Handle upload error */}
          setErrors((prevErrors) => ({
            ...prevErrors,
            docFiles: "Upload failed",
          }));
        },
        async () => {
          const downloadURL = await getDownloadURL(storageRef);
          setFormData((prevData) => ({
            ...prevData,
            docFiles: [
              ...prevData.docFiles,
              { name: file.name, url: downloadURL, type: file.type },
            ],
          }));
          setLoading(false);
          setProgress(100);
        }
      );
    } catch (error) {
      setLoading(false);
      setErrors((prevErrors) => ({
        ...prevErrors,
        docFiles: "Upload failed",
      }));
    }
  }, []);
  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };
  const handlePhoneNumberInput = (e) => {
    const { name, value } = e.target;
    // Allow '+' at the beginning and digits elsewhere
    const sanitizedValue = value.replace(/[^\d+]/g, "");
    const trimmedValue = sanitizedValue.slice(0, 21); // +20 digits max
    setFormData((prevData) => ({
      ...prevData,
      [name]: trimmedValue,
    }));
  };

  const validatePhoneNumber = (phoneNumber) => {
    if (phoneNumber === null) return true;
    const length = phoneNumber.replace(/^\+/, "").length; // Remove '+' for length check
    return length >= 0 && length <= 20;
  };

  const handleRemove = async (file) => {
    try {
      const storageRef = ref(storage, `invoviceFiles/${file.name}`);
      await deleteObject(storageRef);
      setFormData((prevData) => ({
        ...prevData,
        docFiles: prevData.docFiles.filter((f) => f.name !== file.name),
      }));
      toast.success(`${file.name} deleted successfully`);
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.error(`Error deleting file: ${error.message}`);
    }
  };
  const handleInvoice = async (e) => {
    const fileInput = e.target;
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      console.error("No file selected.");
      return;
    }

    const file = fileInput.files[0];

    if (file) {
      try {
        setLoading(true);
        const storageRef = ref(storage, `invoviceFiles/${file.name}`);
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);

        // Update the formData with the download URL
        setFormData((prevData) => ({
          ...prevData,
          invoiceDetail: {
            ...prevData.invoiceDetail,
            invoiceFile: { name: file.name, url: downloadURL },
          },
        }));

        toast.success("Uploaded successfully!");
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error("Error uploading file: " + error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  // console.log(formData)

  return (
    <>
      <div>
        {/* <div className="hidden sm:block">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full border border-red">
          {/* <Header title="Shipment Details" /> */}
          <div className="p-4 bg-cus-gray">
            <div className="mb-3">
              <button
                type="button"
                onClick={onBack}
                // onClick={() => handleButtonClick("bookshipment")}
                className="w-full md:w-auto flex rounded-[5px] items-center space-x-4 py-2 px-4 text-white btnBg"
              >
                <FaArrowLeft className="mr-2" />  Back
              </button>
            </div>
            <div className="p-4 mx-auto bg-white border rounded-md">
              <div className="">
                <div>
                  <input
                    type="radio"
                    id="html"
                    name="fav_language"
                    value="HTML"
                    onClick={() => handleButtonClick("form")}
                    className="mr-2"
                    checked={showForm}
                  />
                  <label htmlFor="html" className="mr-4">
                    Manual Method
                  </label>

                  <input
                    type="radio"
                    id="html"
                    name="fav_language"
                    value="HTML"
                    className="mr-2"
                    onClick={() => handleButtonClick("invoice")}
                  />
                  <label htmlFor="html" className="mr-4">
                    Invoice
                  </label>
                </div>

                <div>
                  {showForm && (
                    <div>
                      {/* Collection */}
                      <h2 className="mx-[30px] font-bold text-xl mt-4">
                        Collection address{" "}
                      </h2>
                      <div className=" mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="name"
                          >
                            <span className="text-red-500">*</span> Name
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="loadName"
                            name="loadName"
                            onChange={handleInputChange}
                            value={formData.loadName}
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            Company Name
                          </label>
                          <input
                            type="text"
                            placeholder=" Company Name "
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="loadAddress_CompanyName"
                            id="loadAddress_CompanyName"
                            onChange={handleInputChange}
                            value={formData.loadAddress_CompanyName}
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="name"
                          >
                            <span className="text-red-500">*</span> Reference
                            Customer
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="loadAddress_ReferenceCustomer"
                            name="loadAddress_ReferenceCustomer"
                            onChange={handleInputChange}
                            value={formData?.loadAddress_ReferenceCustomer}
                          />
                        </div>
                      </div>
                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> Address
                          </label>
                          <input
                            type="text"
                            placeholder="Address"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="loadAddress"
                            id="loadAddress"
                            onChange={handleInputChange}
                            value={formData.loadAddress}
                          />
                        </div>

                        {/* <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            Address line 2
                          </label>
                          <input
                            type="text"
                            placeholder="Address"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="loadAddress2"
                            id="loadAddress2"
                            onChange={handleInputChange}
                            value={formData.loadAddress2} />
                        </div> */}
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> Zip Code
                          </label>
                          <input
                            type="text"
                            placeholder="Zip Code"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="loadPostalCode"
                            id="loadPostalCode"
                            onChange={handleInputChange}
                            value={formData.loadPostalCode}
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2 ">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> City
                          </label>
                          <input
                            type="text"
                            placeholder="city name"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="loadCity"
                            onChange={handleInputChange}
                            value={formData.loadCity}
                            name="loadCity"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> Load Country
                          </label>
                          <CountrySelectInput
                            label=""
                            onChange={handleInputChange}
                            value={formData.loadCountry}
                            name="loadCountry"
                            id="loadCountry"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="Mblenum"
                          >
                            Mobile Number
                          </label>
                          <input
                            type="tel"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="loadAddress_PhoneNumber"
                            id="loadAddress_PhoneNumber"
                            onChange={handlePhoneNumberInput}
                            value={formData.loadAddress_PhoneNumber}
                            maxLength="20"
                          />
                          {formData.loadAddress_PhoneNumber.length >= 0 &&
                            formData.loadAddress_PhoneNumber.length > 20 && (
                              <p className="text-red-500 text-xs mt-1">
                                Please enter valid phone number.
                              </p>
                            )}
                        </div>
                      </div>
                      <h2 className="mx-[30px] font-bold text-xl mt-4">
                        Delivery address{" "}
                      </h2>
                      <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="name"
                          >
                            <span className="text-red-500">*</span> Name
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="unloadName"
                            name="unloadName"
                            onChange={handleInputChange}
                            value={formData.unloadName}
                          />
                        </div>

                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            Company Name
                          </label>
                          <input
                            type="text"
                            placeholder=" Company Name "
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="unloadAddress_CompanyName"
                            id="unloadAddress_CompanyName"
                            onChange={handleInputChange}
                            value={formData.unloadAddress_CompanyName}
                          />
                        </div>
                      </div>
                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> Address
                          </label>
                          <input
                            type="text"
                            placeholder="Address"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="unloadAddress"
                            id="unloadAddress"
                            onChange={handleInputChange}
                            value={formData.unloadAddress}
                          />
                        </div>

                        {/* <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            Address line 2
                          </label>
                          <input
                            type="text"
                            placeholder="Address"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="unloadAddress2"
                            id="unloadAddress2"
                            onChange={handleInputChange}
                            value={formData.unloadAddress2} />
                        </div> */}
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> Zip Code
                          </label>
                          <input
                            type="text"
                            placeholder="Zip Code"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="unloadPostalCode"
                            id="unloadPostalCode"
                            onChange={handleInputChange}
                            value={formData.unloadPostalCode}
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2 ">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> City
                          </label>
                          <input
                            type="text"
                            placeholder="city name"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="unloadCity"
                            onChange={handleInputChange}
                            value={formData.unloadCity}
                            name="unloadCity"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> Country
                          </label>
                          <CountrySelectInput
                            label=""
                            onChange={handleInputChange}
                            value={formData.unloadCountry}
                            name="unloadCountry"
                            id="unloadCountry"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="unloadAddress_PhoneNumber"
                          >
                            Mobile Number
                          </label>
                          <input
                            type="tel"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            name="unloadAddress_PhoneNumber"
                            id="unloadAddress_PhoneNumber"
                            onChange={handlePhoneNumberInput}
                            value={formData.unloadAddress_PhoneNumber}
                            minLength="0"
                            maxLength="20"
                          />
                          {formData.unloadAddress_PhoneNumber !== null &&
                            formData.unloadAddress_PhoneNumber.length > 0 &&
                            (formData.unloadAddress_PhoneNumber.length < 1 ||
                              formData.unloadAddress_PhoneNumber.length >
                              20) && (
                              <p className="text-red-500 text-xs mt-1">
                                Please enter a phone number between 1 and 20
                                digits.
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mx-[30px]">
                        <div className="flex flex-col gap-1 py-2 ">
                          <label
                            className="w-full text-sm font-normal"
                            htmlFor="loadAddress"
                          >
                            <span className="text-red-500">*</span> Mode of
                            Transport
                          </label>
                          <TransportationMode
                            formData={formData}
                            setFormData={setFormData}
                          />
                        </div>
                      </div>
                      {formData.pcsPackage.map((formItem, index) => (
                        <div
                          key={`pcsPackage-${index}`}
                          className="mx-[30px] flex-wrap justify-between flex items-center gap-5"
                        >
                          {/* Weight */}
                          <div className="w-full lg:w-[10%] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal"
                              htmlFor={`pcsPackage-quantity-${index}`}
                            >
                              Quantity <span className="text-red-500">*</span>
                              {/* first number quantity */}
                            </label>
                            <input
                              type="number"
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none 
                              active:border-cus-blue focus:border-cus-blue"
                              id={`pcsPackage-quantity-${index}`}
                              onChange={(e) =>
                                handlePcsOfPkgInput(
                                  index,
                                  "pcsPackage-quantity",
                                  e
                                )
                              }
                              onKeyDown={(e) => {
                                if (
                                  e.key === "e" ||
                                  e.key === "E" ||
                                  e.key === "+" ||
                                  e.key === "-"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              value={formData.pcsPackage[index].quantity} // Add this line
                            />
                          </div>
                          <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal"
                              htmlFor={`weight-${index}`}
                            >
                              Weight<span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center">
                              <input
                                type="number"
                                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                name={`weight-${index}`}
                                id={`weight-${index}`}
                                onChange={(e) =>
                                  handlePcsOfPkgInput(index, "weight", e)
                                }
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "E" ||
                                    e.key === "+" ||
                                    e.key === "-"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={
                                  formData.pcsPackage[index]?.weight.value || ""
                                }
                              />
                              <select
                                className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                name={`weight-unit-${index}`}
                                id={`weight-unit-${index}`}
                                onChange={(e) =>
                                  handleUnitChange(index, "weight", e)
                                }
                                value={
                                  formData.pcsPackage[index]?.weight.unit || ""
                                }
                              >
                                <option value="kg">kg</option>
                                <option value="lbs">lbs</option>
                              </select>
                            </div>
                          </div>

                          {/* Length */}
                          <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal"
                              htmlFor={`length-${index}`}
                            >
                              Length<span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center">
                              <input
                                type="number"
                                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                name={`length-${index}`}
                                id={`length-${index}`}
                                onChange={(e) =>
                                  handlePcsOfPkgInput(index, "length", e)
                                }
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "E" ||
                                    e.key === "+" ||
                                    e.key === "-"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={
                                  formData.pcsPackage[index]?.length.value || ""
                                }
                              />
                              <select
                                className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                name={`length-unit-${index}`}
                                id={`length-unit-${index}`}
                                onChange={(e) =>
                                  handleUnitChange(index, "length", e)
                                }
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "E" ||
                                    e.key === "+" ||
                                    e.key === "-"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={
                                  formData.pcsPackage[index]?.length.unit || ""
                                }
                              >
                                <option value="cm">cm</option>
                                <option value="in">in</option>
                              </select>
                            </div>
                          </div>
                          {/* Width */}
                          <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal"
                              htmlFor={`width-${index}`}
                            >
                              Width<span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center">
                              <input
                                type="number"
                                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                name={`width-${index}`}
                                id={`width-${index}`}
                                onChange={(e) =>
                                  handlePcsOfPkgInput(index, "width", e)
                                }
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "E" ||
                                    e.key === "+" ||
                                    e.key === "-"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={
                                  formData.pcsPackage[index]?.width.value || ""
                                }
                              />
                              <select
                                className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                name={`width-unit-${index}`}
                                id={`width-unit-${index}`}
                                onChange={(e) =>
                                  handleUnitChange(index, "width", e)
                                }
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "E" ||
                                    e.key === "+" ||
                                    e.key === "-"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={
                                  formData.pcsPackage[index]?.width.unit || ""
                                }
                              >
                                <option value="cm">cm</option>
                                <option value="in">in</option>
                              </select>
                            </div>
                          </div>
                          {/* Height */}
                          <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal"
                              htmlFor={`height-${index}`}
                            >
                              Height<span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center">
                              <input
                                type="number"
                                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                name={`height-${index}`}
                                id={`height-${index}`}
                                onChange={(e) =>
                                  handlePcsOfPkgInput(index, "height", e)
                                }
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "E" ||
                                    e.key === "+" ||
                                    e.key === "-"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={
                                  formData.pcsPackage[index]?.height.value || ""
                                }
                              />
                              <select
                                className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                name={`height-unit-${index}`}
                                id={`height-unit-${index}`}
                                onChange={(e) =>
                                  handleUnitChange(index, "height", e)
                                }
                                value={
                                  formData.pcsPackage[index]?.height.unit || ""
                                }
                              >
                                <option value="cm">cm</option>
                                <option value="in">in</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="flex justify-between gap-5 items-center px-5 py-2">
                        <div className="flex gap-1 items-center">
                          <div
                            className="mx-[20px] mt- "
                            onClick={handleAddMorePcsOfpackage}
                          >
                            <FaPlus className="text-[20px] text-[#03336E] " />
                          </div>

                          <div
                            className="mx-[5px]  "
                            onClick={handleRemovePcsOfpackage}
                          >
                            <FaMinus className="text-[20px] text-[#03336E] " />
                          </div>
                        </div>

                        <div className="px-5 flex  items-center gap-5">
                          <p className="text-[14px]"> Total Weight:</p>
                          <p className="text-[14px] font-extrabold">
                            {formData.totalWeight
                              ? formData.totalWeight
                              : totalWeight}
                          </p>
                        </div>
                      </div>
                      {/* {items} */}
                      <div className="flex flex-col md:w-1/2 py-3 gap-4 px-5">
                        <label
                          className="w-full text-sm font-normal "
                          htmlFor="username"
                        >
                          Select Package Type
                        </label>
                        <select
                          className="w-full  p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name="pkgType"
                          id="pkgType"
                          onChange={handleInputChange}
                          value={formData.pkgType}
                        >
                          <option value="pallet">Pallet </option>
                          <option value="box">Box</option>
                          <option value="container">Container</option>
                        </select>
                      </div>{" "}
                      <div className="mx-[30px] mt-2">
                        <Upload.Dragger
                          showUploadList={false}
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.jpg,.jpeg,.png,.gif"
                          beforeUpload={(file) => {
                            handleFileUpload(file);
                            return false; // Prevent default upload behavior
                          }}
                          onDrop={(e) => {
                            const files = e.dataTransfer.files;
                            Array.from(files).forEach(handleFileUpload);
                          }}
                          name="files"
                          multiple={true}
                        >
                          <div style={{ position: "relative", minHeight: "120px" }}>
                            <div style={{ opacity: loading ? 0.5 : 1 }}>
                              <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                              </p>
                              <p className="ant-upload-text">
                                Supporting Documents (E.G. Commercial Invoice, Packing List, Datasheets)
                              </p>
                              <p className="ant-upload-hint">
                                Only PDF, Doc, Excel, CSV, and Image files are allowed
                              </p>
                            </div>
                            {loading && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "80%",
                                }}
                              >
                                <Progress
                                  type="line"
                                  percent={progress}
                                  strokeWidth={4}
                                  status="active"
                                />
                              </div>
                            )}
                          </div>
                        </Upload.Dragger>
                        {formData.docFiles.length > 0 && (
                          <Upload
                            listType="picture"
                            fileList={formData.docFiles.map((file, index) => ({
                              uid: `${index}`,
                              name: file.name,
                              status: "done",
                              url: file.url,
                              type: file.type,
                            }))}
                            onRemove={(file) => {
                              const newFiles = formData.docFiles.filter(
                                (f) => f.name !== file.name
                              );
                              setFormData({ ...formData, docFiles: newFiles });
                            }}
                          />
                        )}
                        {errors.docFiles && (
                          <p className="text-red-500 text-sm mt-2">
                            {errors.docFiles}
                          </p>
                        )}
                      </div>
                      <div>
                        <div className="flex gap-5 items-center  mt-8">
                          <div className="mx-[30px] flex items-center gap-4">
                            <h2 className="text-xl font-bold ">Item details</h2>
                            <FaCirclePlus
                              className="text-[22px] text-[#03336e]"
                              onClick={handleAddMore}
                            />
                          </div>
                          <div className=" flex items-center gap-2">
                            <h1 className="mt-2">Currency</h1>{" "}
                            {/* Fixed typo here */}
                            <select
                              className="ml-2 p-1 w-full text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              name="currency"
                              id="currency"
                              onChange={handleInputChange}
                              value={formData.currency}
                            >
                              <option value="USD">USD</option>{" "}
                              {/* Changed value to "usd" for dollar */}
                              <option value="EUR">EUR</option>{" "}
                              {/* Changed value to "eur" for Euro */}
                              <option value="GBP">GBP</option>{" "}
                            </select>
                          </div>
                        </div>
                        {formData.items.map((formItem, index) => (
                          <>
                            <div key={`item-${index}`} className="md:px-10">
                              <h2 className="flex gap-3 items-center text-[16px] font-bold text-[gray] mt-6">
                                Item details
                                <FaCircleMinus
                                  onClick={() => handleRemoveService(index)}
                                />
                              </h2>
                              <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                                <div className="flex flex-col gap-1 py-2">
                                  <label
                                    className="w-full text-sm font-normal "
                                    htmlFor="value"
                                  >
                                    <span className="text-red-500">*</span> Item
                                    Name
                                  </label>
                                  <input
                                    type="text"
                                    className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                    id={`itemName-${index}`}
                                    onChange={(e) =>
                                      handleServiceInputChange(
                                        index,
                                        "itemName",
                                        e
                                      )
                                    }
                                    value={formItem.itemName}
                                  />
                                </div>
                                <div className="flex flex-col gap-1 py-2">
                                  <label
                                    className="w-full text-sm font-normal "
                                    htmlFor={`item-quantity-${index}`}
                                  >
                                    <span className="text-red-500">*</span>{" "}
                                    Quantity
                                  </label>
                                  <input
                                    type="number"
                                    className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                    id={`item-quantity-${index}`}
                                    onChange={(e) =>
                                      handleServiceInputChange(
                                        index,
                                        "item-quantity",
                                        e
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "e" ||
                                        e.key === "E" ||
                                        e.key === "+" ||
                                        e.key === "-"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    min="0"
                                    step="any"
                                    // value={formItem.quantity}
                                    value={formData.items[index].quantity}
                                  />
                                </div>
                              </div>

                              <div className=" grid md:grid-cols-2 grid-cols-1 gap-3">
                                <div className="flex flex-col gap-1 py-2">
                                  <label
                                    className="w-full text-sm font-normal "
                                    htmlFor="value"
                                  >
                                    <span className="text-red-500">*</span> Item
                                    Value
                                  </label>
                                  <input
                                    type="number"
                                    className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                    id={`itemValue-${index}`}
                                    onChange={(e) =>
                                      handleServiceInputChange(
                                        index,
                                        "itemValue",
                                        e
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "e" ||
                                        e.key === "E" ||
                                        e.key === "+" ||
                                        e.key === "-"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    min="0"
                                    step="any"
                                    value={formItem.itemValue}
                                  />
                                </div>
                                <div className="flex flex-col gap-1 py-2">
                                  <label
                                    className="w-full text-sm font-normal "
                                    htmlFor="value"
                                  >
                                    <span className="text-red-500">*</span>{" "}
                                    Country of Origin
                                  </label>
                                  <Select
                                    showSearch
                                    id={`countryOrigin-${index}`}
                                    options={countries?.map(
                                      (country, index) => ({
                                        value: country,
                                        label: country,
                                        key: index,
                                      })
                                    )}
                                    onChange={(e) => {
                                      handleAntdServiceInputChange(
                                        index,
                                        "countryOrigin",
                                        e
                                      );
                                    }}
                                    value={formItem.countryOrigin}
                                  />
                                </div>

                                <div className="flex flex-col gap-1 py-2">
                                  <label className="w-full text-sm font-normal">
                                    Do you have Item HS Code?{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <div className="flex gap-4">
                                    <label className="flex items-center">
                                      <input
                                        type="radio"
                                        name={`hasHSCode-${index}`}
                                        value="yes"
                                        checked={
                                          formData.items[index].hasHSCode ===
                                          true
                                        }
                                        onChange={(e) => {
                                          handleServiceInputChange(
                                            index,
                                            "hasHSCode",
                                            e
                                          );
                                          validateHSCode(index);
                                        }}
                                        className="mr-2"
                                      />
                                      Yes
                                    </label>
                                    <label className="flex items-center">
                                      <input
                                        type="radio"
                                        name={`hasHSCode-${index}`}
                                        value="no"
                                        checked={
                                          formData.items[index].hasHSCode ===
                                          false
                                        }
                                        onChange={(e) => {
                                          handleServiceInputChange(
                                            index,
                                            "hasHSCode",
                                            e
                                          );
                                          validateHSCode(index);
                                        }}
                                        className="mr-2"
                                      />
                                      No
                                    </label>
                                  </div>
                                  {errors[`hasHSCode-${index}`] && (
                                    <p className="text-red-500 text-sm">
                                      {errors[`hasHSCode-${index}`]}
                                    </p>
                                  )}
                                  {formData.items[index].hasHSCode === true && (
                                    <div className="mt-2">
                                      <label
                                        className="w-full text-sm font-normal"
                                        htmlFor="weight"
                                      >
                                        Item HS Code
                                      </label>
                                      <input
                                        type="text"
                                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${errors[`itemHSCode-${index}`]
                                          ? "border-red-500"
                                          : ""
                                          }`}
                                        id={`itemHSCode-${index}`}
                                        onChange={(e) => {
                                          const value = e.target.value.replace(/[^0-9.]/g, "");
                                          handleServiceInputChange(
                                            index,
                                            "itemHSCode",
                                            { target: { value } }
                                          );
                                          validateHSCode(index);
                                        }}
                                        onBlur={(e) => {
                                          // Remove all dots on blur for final storage
                                          const sanitizedValue = e.target.value.replace(/\./g, "");
                                          handleServiceInputChange(index, "itemHSCode", { target: { value: sanitizedValue } });
                                        }}
                                        value={
                                          formData.items[index].itemHSCode || ""
                                        }
                                      />
                                      {errors[`itemHSCode-${index}`] && (
                                        <p className="text-red-500 text-sm">
                                          {errors[`itemHSCode-${index}`]}
                                        </p>
                                      )}
                                    </div>
                                  )}
                                  {formData.items[index].hasHSCode === false && (
                                    <div className="mt-2">
                                      <p className="text-sm mb-2">
                                        <span className="text-red-500">*</span> Please upload the datasheet for this product so we can classify your product.
                                      </p>

                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                        <div className="flex justify-end gap-5 mt-4 border-t border-cus-blue px-5">
                          <div className="mt-2">
                            <p className="text-[14px] font-medium">
                              Total Value :{" "}
                            </p>
                          </div>
                          <div className="mt-2">
                            <p className="text-[14px] font-extrabold ">
                              {formData.cargoValue?.value} {formData.currency}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="border-t border-gray-200 my-4 pt-4 px-5">
                        <label
                          htmlFor="request-manual-description"
                          className="block mb-2 text-sm font-normal text-black"
                        >
                          Additional details (optional)
                        </label>
                        <textarea
                          id="request-manual-description"
                          name="manualDescription"
                          value={formData.manualDescription || ""}
                          onChange={handleInputChange}
                          placeholder="Add any additional details about your request..."
                          rows={3}
                          className="w-full p-2 text-sm border border-gray-300 rounded-md outline-none focus:border-cus-blue"
                        />
                      </div>
                      <div
                        className={`flex flex-col px-5 gap-2 ${requiredDocTouched && !formData.requiredDoc
                          ? "border-2 border-red-500 rounded-md"
                          : ""
                          }`}
                      >
                        <label
                          htmlFor="input-group-1"
                          className="block mb-2 text-lg font-normal text-black"
                        >
                          <span className="text-red-500">*</span> Import
                          documentation required?
                        </label>
                        <div className="flex gap-2">
                          <label className="flex items-center">
                            <input
                              type="radio"
                              name="requiredDoc"
                              value="Required"
                              onChange={handleInputChange}
                              checked={formData.requiredDoc === "Required"}
                            />
                            <span className="ml-2">Required</span>
                          </label>
                          <label className="flex items-center">
                            <input
                              type="radio"
                              name="requiredDoc"
                              value="not_Required"
                              onChange={handleInputChange}
                              checked={formData.requiredDoc === "not_Required"}
                            />
                            <span className="ml-2">Not Required</span>
                          </label>
                        </div>
                      </div>
                      <div className="mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="username"
                          >
                            <span className="text-red-500">*</span> Services
                          </label>
                          <select
                            placeholder="Select"
                            name="serviceType"
                            id="serviceType"
                            onChange={handleInputChange}
                            value={formData.serviceType}
                            className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            required // Added required attribute
                          >
                            <option value="">Select</option>{" "}
                            {/* Added value attribute to each option */}
                            <option value="EOR">EOR</option>
                            <option value="IOR">IOR</option>
                            <option value="White Glove">White Glove</option>
                          </select>
                        </div>
                      </div>
                      <div className="mx-[30px] py-4 w-full flex flex-col gap-3">
                        <div className="flex items-center gap-3">
                          <input
                            type="checkbox"
                            className=""
                            id="insureShipment"
                            name="insureShipment"
                            checked={insureShipment}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="font-normal text-[10px] w-full"
                            htmlFor="insureShipment"
                          >
                            Insure this Shipment
                          </label>
                        </div>
                        <div
                          className={`flex items-center gap-3 ${termsError
                            ? "border-2 border-solid border-red-500 p-2 rounded"
                            : ""
                            }`}
                        >
                          <input
                            type="checkbox"
                            className={`${termsError
                              ? "border-2 border-solid border-red-500"
                              : ""
                              }`}
                            id="agreeTerms"
                            name="agreeTerms"
                            checked={agreeTerms}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className={`font-normal text-[10px] w-full ${termsError ? "text-red-500" : ""
                              }`}
                            htmlFor="agreeTerms"
                          >
                            By clicking I agree to all terms and conditions.
                            <span className="text-red-500">*</span>
                          </label>
                        </div>

                        {termsError && (
                          <p className="text-red-500 text-xs mt-1">
                            You must agree to the terms and conditions.
                          </p>
                        )}
                      </div>
                      <div className=" flex justify-center items-center md:justify-start md:mx-[30px]">
                        <button
                          onClick={handleAddData}
                          className=" bg-cus-blue rounded-md text-white p-2 text-sm md:w-[341px] w-[180px]"
                        >
                          {loading ? "Loading..." : "  Request quotation"}
                        </button>
                      </div>
                    </div>
                  )}

                  {showInvoice && <UploadInvoice />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddressForm;
